import { FC } from 'react';
import { Tooltip } from 'react-tooltip';
import { useTranslate } from 'hooks/useTranslate';

const PlanTableHeader: FC = () => {
  const { t } = useTranslate();

  const invoiceHeaders = [
    { key: 'number', title: 'Nº', width: '5%' },
    { key: 'plan', title: t('Plan'), width: '23%' },
    { key: 'cliff', title: `${t('Cliff')} (${t('meses')})`, width: '9%' },
    { key: 'vesting', title: `${t('Vesting')} (${t('meses')})`, width: '9%' },
    { key: 'units', title: t('NoOfUnits'), width: '9%' },
    { key: 'vested', title: t('Vested'), width: '9%' },
    { key: 'sold', title: t('SoldUnits'), width: '9%' },
    { key: 'strike-price', title: t('StrikePriceUnit'), width: '9%' },
    { key: 'sell-price', title: t('SellingPriceUnit'), width: '9%' },
  ];

  return (
    <thead>
      <tr key="plan-table-header">
        {invoiceHeaders.map((header) => (
          <th
            key={header.key}
            className="text-center"
            style={{ width: header.width }}
          >
            {header.title}
          </th>
        ))}

        <th className="text-center" style={{ width: '9%' }}>
          {t('Profit')}
          <span
            className="fw-normal"
            style={{
              textTransform: 'none',
            }}
          >
            <em
              className="icon ni ni-info notification-icon ml-1 text-primary"
              id="icon-profit-tooltip"
            />
            <Tooltip
              anchorId="icon-profit-tooltip"
              place="top"
              style={{ maxWidth: '300px' }}
            >
              {t('IncentiveValueDetailsNoStrikePrice')}
            </Tooltip>
          </span>
        </th>
      </tr>
    </thead>
  );
};

export default PlanTableHeader;
